import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function StatsSection() {
  const stats = [
    { icon: 'ri-article-line', label: '文章总数', value: `${articles.length * 128}+` },
    { icon: 'ri-user-smile-line', label: '每日访客', value: '50万+' },
    { icon: 'ri-fire-line', label: '今日热点', value: `${articles.filter((a) => a.isHot).length * 3}个` },
    { icon: 'ri-folder-line', label: '内容分类', value: `${categories.length}大类` },
  ];

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
      <div className="bg-background-100 border border-background-200/70 rounded-lg p-8 md:p-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 text-primary-500">
                <i className={`${stat.icon} text-2xl`}></i>
              </div>
              <div className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-1">
                {stat.value}
              </div>
              <div className="text-xs text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}